export enum AuditTypeEnum {
  Information = 'Information',
  Warning = 'Warning',
  Error = 'Error',
}